import produce from 'immer';
import { FETCH_SHIPMENT_STATUS_PENDING } from '../constants/actions/sendReceiptActions';
import ISendReceiptReducer from '../interfaces/reducers/sendReceiptReducer';

const initialValues: ISendReceiptReducer = {
	shipmentLoading: false,
	shipmentError: false,
	expressServices: null,
	expressServicesLoading: false,
	expresServicesError: false,
};

const sendReceiptReducer = produce((draft: ISendReceiptReducer, action) => {
	switch (action.type) {
		case FETCH_SHIPMENT_STATUS_PENDING: {
			draft.shipmentLoading = true;
			draft.shipmentError = false;
			break;
		}
		default: {
			break;
		}
	}
}, initialValues);

export default sendReceiptReducer;
